import { RootState } from '../state';

export const getAuth = (state: RootState) => state.auth;
